import { CardMedia, Box } from "@mui/material";
import { Job } from "../types";
import { Business } from "@mui/icons-material";
import { getImagePath } from "../../../util/envFn";

export type JobCompanyIconProps = {
    job: Job;
    size?: number;
}

const JobCompanyIcon = ({ job, size = 60 }: JobCompanyIconProps) => {
    // Check if company logo exists
    if (job.companyLogo) {
        return (
            <Box sx={{ width: size, height: size, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb: 2 }}>
                <CardMedia
                    component="img"
                    src={job.companyLogo}
                    alt={job.company}
                    sx={{
                        height: size,
                        width: 'auto',
                        objectFit: 'contain'
                    }}
                />
            </Box>
        );
    }

    if (!job.fromCrawlerProvider) {
        return (
            <Box sx={{ width: size, height: size, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb: 2 }}>
                <CardMedia
                    component="img"
                    src={getImagePath(`/logo/icon.jpeg`)}
                    alt={job.company}
                    sx={{
                        height: size,
                        width: 'auto',
                        objectFit: 'contain'
                    }}
                />
            </Box>
        );
    }

    // Option 1: Display a building icon
    return (
        <Box
            sx={{
                width: size,
                height: size,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                bgcolor: '#f0f4f8',
            }}
        >
            <Business sx={{ fontSize: size * 0.6, color: '#546e7a' }} />
        </Box>
    );
}

export default JobCompanyIcon;
